import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  template: `
    <div class="tooltip-content">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
    .tooltip-content {
      max-width: 200px;
      background-color: #fff;
      border: 1px solid #ccc;
      padding: 10px;
    }
    `
  ]
})
export class CustomTooltipComponent {}
